import { jsxs, jsx } from "react/jsx-runtime";
import assert from "assert";
import dedent from "dedent";
import { Box } from "../Box/Box.mjs";
import { Text } from "../Text/Text.mjs";
import { IconContainer } from "../icons/IconContainer.mjs";
import { IconStarActiveSvg } from "../icons/IconStar/IconStarActiveSvg.mjs";
import { IconStarHalfSvg } from "../icons/IconStar/IconStarHalfSvg.mjs";
import { IconStarSvg } from "../icons/IconStar/IconStarSvg.mjs";
import { iconSlotSpace } from "../private/iconSlotSpace.mjs";
import { inlineFlex } from "./Rating.css.mjs";
const getPercent = (rating, position) => Math.round(Math.min(Math.max(rating - position, 0), 1) * 100);
const RatingStar = ({ percent, ...restProps }) => {
  let component = IconStarSvg;
  if (percent >= 25 && percent < 75) {
    component = IconStarHalfSvg;
  }
  if (percent >= 75) {
    component = IconStarActiveSvg;
  }
  return /* @__PURE__ */ jsx(IconContainer, { ...restProps, children: (svgProps) => /* @__PURE__ */ jsx(Box, { component, ...svgProps }) });
};
const ratingArr = [...Array(5)];
const Rating = ({
  rating,
  size = "standard",
  weight,
  variant = "full",
  tone = "brandAccent",
  "aria-label": ariaLabel,
  data
}) => {
  assert(
    !rating || rating >= 0 && rating <= 5,
    "Rating must be between 0 and 5"
  );
  if (process.env.NODE_ENV !== "production") {
    if (typeof weight !== "undefined" && variant === "starsOnly") {
      console.warn(
        dedent`
          The "weight" prop is not valid with the "starsOnly" variant as there is no visible text. Either remove the \`weight\` prop or choose an alternative \`variant\`.
             <Rating
            %c-  weight="strong"
            %c   variant="starsOnly"
             />
        `,
        "color: red",
        "color: inherit"
      );
    }
  }
  return /* @__PURE__ */ jsxs(Text, { size, data, weight, children: [
    /* @__PURE__ */ jsx(
      Box,
      {
        component: "span",
        className: inlineFlex,
        "aria-label": ariaLabel || `${rating.toFixed(1)} out of ${ratingArr.length}`,
        children: variant === "minimal" ? /* @__PURE__ */ jsx(
          RatingStar,
          {
            percent: 100,
            tone: tone === "neutral" ? "neutral" : "brandAccent"
          }
        ) : ratingArr.map((_, position) => /* @__PURE__ */ jsx(
          RatingStar,
          {
            percent: getPercent(rating, position),
            tone: tone === "neutral" ? "neutral" : "brandAccent"
          },
          position
        ))
      }
    ),
    variant !== "starsOnly" && /* @__PURE__ */ jsx(Box, { component: "span", paddingLeft: iconSlotSpace, "aria-hidden": true, children: rating.toFixed(1) })
  ] });
};
export {
  Rating
};
